// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '삼성제약',
  targetSheetName: '① 제품리스트+발매예정 제품리스트',
  headerRowIndex: 5,
  headerRowCount: 1,
  dataStartRowIndex: 6,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '약가(원)',
    commissionRate: '26년 코드',
  },
  requiredHeaders: [
    'NO',
    '분류',
    '보험코드',
    '제품명',
    '성분명/함량',
    '약가(원)',
    '포장단위',
    '26년 코드',
    '특판 (4월~)',
    '대조약',
  ],
});
